import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ArcoVue from '@arco-design/web-vue'
import ArcoVueIcon from '@arco-design/web-vue/es/icon'
import '@arco-design/web-vue/dist/arco.css'
import './assets/style/mobile.scss'
import App from './App.vue'
import router from './router'
import { ensureCsrfToken } from './utils/request'
import './assets/style/global.scss'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(ArcoVue)
app.use(ArcoVueIcon)
// 全局错误捕获
app.config.errorHandler = (err, vm, info) => {
  console.error('[Vue Error]', err, info)
}
window.addEventListener('error', (e) => {
  console.error('[Global Error]', e.message, e.filename, e.lineno)
})
window.addEventListener('unhandledrejection', (e) => {
  console.error('[Unhandled Promise]', e.reason)
})

// 预取 CSRF token 后再挂载：已登录用户刷新/直达 dashboard 时 csrfToken 内存为空，
// 首屏并发 POST 会因无 token 触发 CSRFTokenError 400（拦截器虽会重试救回，但每次刷新都刷屏）。
// 此处 mount 前取好 token（未登录时返回 null，不影响登录页），彻底消除首屏 CSRF 竞态。

// 版本自检（2026-10-17 治本「部署了前端不显示、强刷无效」）：
// 浏览器可能缓存着旧 index.html → 加载旧 chunk（assets 30d immutable）。
// 每次构建生成 dist/version.json（nginx 对 .json 走 no-cache），
// 启动时拉取比对，不一致说明本地是旧版本 → 带时间戳整页重载，
// 强制绕过缓存拿新 index.html。最多自动重载 1 次，防循环。
declare const __BUILD_VERSION__: string
async function checkBuildVersion() {
  if (location.search.includes('_v=')) return // 刚重载过，不再自检
  try {
    const res = await fetch('/version.json', { cache: 'no-store' })
    if (!res.ok) return
    const data = (await res.json()) as { v?: string }
    if (data.v && data.v !== __BUILD_VERSION__) {
      location.replace(`${location.pathname}?_v=${Date.now()}${location.hash}`)
    }
  } catch {
    /* 拉取失败不阻塞启动 */
  }
}
void checkBuildVersion()

async function bootstrap() {
  await ensureCsrfToken()
  app.mount('#app')
}
bootstrap()
